<template>
  <div class="flex items-center">
    <router-link
      :to="url"
      @click.stop.prevent
      class="text-inherit hover:text-primary"
      >{{ params.data.title }}</router-link
    >
  </div>
</template>

<script>
export default {
  name: "EntityCellRendererLink",
  computed: {
    url() {
      return this.params.data.openLink;
    }
  }
};
</script>
